/*
This file is located in the main branch
Last time the file was updated (UTC): [11.12.2024 08:50:34]
Permissions to update outside the main branch: [false]
*/

import {
    DynamicListAddButton,
    DynamicListWrapperProps,
    requiredRule,
    ValidatedDynamicListFormComponentProps,
    ValidatedInput,
} from '@finbeat/react-toolkit';
import { Trans } from 'react-i18next';
import { Table } from 'reactstrap';
import { TradeOrgAddForm } from './TradeOrgChangeModal';

const TradeOrgApiHeadersFormWrapper = ({ children, ...props }: DynamicListWrapperProps) => {
    return (
        <Table bordered>
            <thead>
                <tr className="align-middle">
                    <th className="w-45 text-center">
                        <Trans i18nKey={'BackOfficeHeader'} />
                    </th>
                    <th className="w-45 text-center">
                        <Trans i18nKey={'BackOfficeValue'} />
                    </th>
                    <th className="w-10 text-center">
                        <DynamicListAddButton {...props} />
                    </th>
                </tr>
            </thead>
            <tbody>{children}</tbody>
        </Table>
    );
};

const TradeOrgApiHeadersForm = ({
    idx,
    formHasRole,
}: ValidatedDynamicListFormComponentProps & {
    formHasRole: boolean;
}) => {
    return (
        <>
            <td>
                <ValidatedInput<TradeOrgAddForm>
                    name={`apiSettings.httpHeaders.${idx}.header`}
                    isFloating={false}
                    rules={{ required: requiredRule }}
                    disabled={!formHasRole}
                />
            </td>
            <td>
                <ValidatedInput<TradeOrgAddForm>
                    name={`apiSettings.httpHeaders.${idx}.value`}
                    isFloating={false}
                    rules={{ required: requiredRule }}
                    disabled={!formHasRole}
                />
            </td>
        </>
    );
};

export { TradeOrgApiHeadersForm, TradeOrgApiHeadersFormWrapper };
